const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\S]{8,}$/; // At least 8 characters, 1 letter, 1 number
const phoneNumberRegex = /^\d+$/; // Only phoneNumber Digits
const isNumberRegex = /^[0-9]$/

export {
    emailRegex,
    passwordRegex,
    phoneNumberRegex,
    isNumberRegex
}